module.exports = __webpack_public_path__ + "img/shwoImageInfo1.b51f5996.png";